import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-opacity": ".3",
  "fill-rule": "evenodd",
  d: "M12 0C8.277 0 5.247 1.05 3.148 3.148 1.05 5.247 0 8.277 0 12s1.05 6.753 3.148 8.852C5.247 22.95 8.277 24 12 24s6.753-1.05 8.852-3.148C22.95 18.753 24 15.723 24 12s-1.05-6.753-3.148-8.852C18.753 1.05 15.723 0 12 0M8.25 7C7.56 7 7 7.56 7 8.25v1.5a1.25 1.25 0 1 0 2.5 0v-1.5C9.5 7.56 8.94 7 8.25 7m7.5 0c-.69 0-1.25.56-1.25 1.25v1.5a1.25 1.25 0 1 0 2.5 0v-1.5C17 7.56 16.44 7 15.75 7M7.946 17.325l.002-.005q.004-.015.022-.055c.023-.054.063-.14.123-.248.12-.217.317-.513.614-.81C9.282 15.632 10.283 15 12 15s2.718.632 3.293 1.207c.297.297.494.593.614.81a3 3 0 0 1 .146.303l.002.005a1 1 0 0 0 1.894-.641L17 17l.949-.317v-.002l-.002-.002-.002-.006-.005-.016a2 2 0 0 0-.071-.18 5 5 0 0 0-.213-.431 5.7 5.7 0 0 0-.949-1.253C15.782 13.868 14.283 13 12 13s-3.782.868-4.707 1.793a5.7 5.7 0 0 0-.948 1.253 5 5 0 0 0-.284.611l-.006.016-.002.006v.002l-.001.002L7 17l-.948-.316a1 1 0 0 0 1.894.64M17 17l-.948.317z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }